import { FC, ReactNode } from 'react';

import { DropdownMenuItem } from '@savgroup-front-common/primitive/ui/dropdown-menu';

import { MenuRowContent } from '../../../MenuRowContent/MenuRowContent';

interface HeaderProfileMenuItemProps {
  icon: ReactNode;
  trailingIcon?: ReactNode;
  onSelect: (event: Event) => void;
  variant?: 'default' | 'destructive';
  dataTestId?: string;
  children: ReactNode;
}

export const HeaderProfileMenuItem: FC<HeaderProfileMenuItemProps> = ({
  icon,
  trailingIcon,
  onSelect,
  variant = 'default',
  dataTestId,
  children,
}) => {
  return (
    <DropdownMenuItem
      variant={variant}
      onSelect={onSelect}
      data-testid={dataTestId}
    >
      <MenuRowContent icon={icon} trailingIcon={trailingIcon} variant={variant}>
        {children}
      </MenuRowContent>
    </DropdownMenuItem>
  );
};
